var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99979 0.890625C6.59334 0.890625 5.21848 1.30768 4.04906 2.08906C2.87965 2.87044 1.9682 3.98105 1.42998 5.28043C0.891753 6.57982 0.750929 8.00962 1.02531 9.38904C1.2997 10.7685 1.97696 12.0355 2.97147 13.0301C3.96598 14.0246 5.23306 14.7018 6.61248 14.9762C7.9919 15.2506 9.4217 15.1098 10.7211 14.5715C12.0205 14.0333 13.1311 13.1219 13.9125 11.9525C14.6938 10.783 15.1109 9.40818 15.1109 8.00174C15.1109 6.11575 14.3617 4.30701 13.0281 2.97342C11.6945 1.63983 9.88577 0.890625 7.99979 0.890625ZM1.77756 8.00174C1.77799 6.50657 2.31948 5.06208 3.30201 3.93507L12.0665 12.6995C11.1651 13.4779 10.0592 13.9812 8.88029 14.1497C7.70134 14.3183 6.49878 14.1449 5.41543 13.6503C4.33207 13.1556 3.41342 12.3605 2.76858 11.3592C2.12374 10.358 1.77978 9.19267 1.77756 8.00174ZM12.6976 12.0684L3.93312 3.30396C5.12572 2.30748 6.64806 1.79338 8.20062 1.86279C9.75319 1.9322 11.2236 2.5801 12.3225 3.67903C13.4214 4.77795 14.0693 6.24834 14.1387 7.8009C14.2081 9.35346 13.694 10.8758 12.6976 12.0684Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.0590c8af68955f99cff53778b8b8d54e.svg";
export { ForwardRef as ReactComponent };